import script from "./profileTabs.vue?vue&type=script&lang=js"
export * from "./profileTabs.vue?vue&type=script&lang=js"

import "./profileTabs.vue?vue&type=style&index=0&id=8c6ffed0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c6ffed0"]])

export default __exports__